import { DatePicker } from '@/shared/components'

type BirthDateSectionProps = {
  value: string
  errorMessage?: string
  maxBirthDate: string
  isUnder18: boolean
  disabled?: boolean
  onChange: (value: string) => void
}

export function BirthDateSection({
  value,
  errorMessage,
  maxBirthDate,
  isUnder18,
  disabled = false,
  onChange
}: BirthDateSectionProps) {
  return (
    <>
      <div className="relative z-[13000] mb-4 flex flex-col gap-4 md:mb-0 md:flex-row md:items-end md:justify-between md:gap-5">
        <div className="w-full">
          <DatePicker
            label="Date of Birth"
            value={value}
            onChange={onChange}
            placeholder="MM/DD/YYYY"
            error={errorMessage}
            max={maxBirthDate}
            disabled={disabled}
            required
          />
        </div>
      </div>

      {isUnder18 ? (
        <div
          style={{ marginTop: '-20px' }}
          className="animate-fade-in-up rounded-xl border border-[#f5e7de] border-l-4 border-l-primary bg-[#FEF7F4] px-6 py-5 text-left text-gray-dark"
        >
          <p className="text-sm">
            You must be at least 18 years old to enroll in CDL training. Please come back once
            you meet the age requirement.
          </p>
        </div>
      ) : null}
    </>
  )
}
